import LayoutActividad from "../../../components/LayoutActividad";
import Extincion from "../../../images/modulo14/lenguaextincion.png";
import QuechuaNietos from "../../../images/modulo14/quechuanietos.png";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";

const Actividad7 = () => {
  const infoUnidad = modulo14.content[0];
  const infoAct = modulo14.content[0].activities[9];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo14.content[0].name}: ${modulo14.content[0].activities[10].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[10].path}`,
    titlePrev: `${modulo14.content[0].name}: ${modulo14.content[0].activities[8].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[8].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>
      <div className="bg-light p-3 p-md-5 mt-5 rounded">
        <div className="row align-items-center">
          <div className="col-md-8 col-12 p-md-3 p-0">
            <h4 className="mb-4">
              <strong>En peligro de extinción</strong>
            </h4>
            <p className="mt-1">
              ¿Por qué desaparecen las lenguas? Sencillamente, porque{" "}
              <strong>no se hablan</strong>. A lo largo de la historia del Perú,
              se han extinguido muchas lenguas debido a diversas circunstancias.
              Con la llegada de los europeos, algunas poblaciones disminuyeron y
              prefirieron adoptar las lenguas más generales, como el quechua o
              el castellano.
            </p>
          </div>
          <div className="col-md-4 col-12">
            <img
              src={Extincion}
              className="bg-white img-fluid rounded w-100"
              alt="lengua"
            />
          </div>
          <div className="col-md-4 col-12">
            <img
              src={QuechuaNietos}
              className="bg-white img-fluid rounded w-100"
              alt="dialogo"
            />
          </div>
          <div className="col-md-8 col-12 p-md-3 p-0">
            <p>
              También se dejan de lado las lenguas originarias porque el
              castellano es percibido como más{" "}
              <strong>útil o más prestigioso</strong>.
            </p>
            <p>
              Hace mucho tiempo se discute si debemos dejar desaparecer las
              lenguas que ya no se usan o si debemos tratar de revitalizarlas.
              Ese es uno de los retos más difíciles que vive nuestro país.
            </p>
          </div>
        </div>
      </div>
      <GuiaDocente>
        <ul>
          <li>
            Pida que lean, en voz alta, el texto
            titulado En peligro de extinción. Pídales también que observen las
            imágenes que acompañan al texto. Pregunte por qué
            las lenguas se extinguen y qué consecuencias puede tener dicha
            extinción. Cierre la sesión enfatizando que las lenguas no tienen
            una vida independiente de las personas que las usan. Por ello, su
            supervivencia o extinción depende de que sus hablantes las mantengan
            o se olviden de ellas.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad7;
